export default "__VITE_ASSET__d1fac5ed__"